export interface RequestEncodeShortLinkInterface {
  link: string;
}

export class ResponseEncodeShortLinkPresenter {
  link: string;

  constructor(data: any) {
    this.link = data.link || process.env.NEXT_PUBLIC_NEXTAUTH_URL;
  }
}
